var t=(r,e)=>Math.floor(Math.random()*(e-r+1))+r,n=r=>{let e=Number.parseFloat(r);return Number.isNaN(e)?r:e},o=(r,e="en-US")=>r.toLocaleString(e);

export { t as a, n as b, o as c };
//# sourceMappingURL=chunk-G4QZ5YXG.mjs.map
//# sourceMappingURL=chunk-G4QZ5YXG.mjs.map